import React from "react";
import { Grid } from "@mui/material";
import CustomTimeline from "../../../../common/components/CustomTimeline";
import CustomDashboardCard from "../../../../common/components/CustomDashboardCard/CustomDashboardCard";
import Loader from "../../../../common/Lottifiers/Loader/Loader";
import Compdirection from "../../../../common/themes/CompDirection";

interface timelineList {
  event_name?: string;
  event_date?: string;
  event_description?: string;
}

interface timelineListProps {
  timeline: timelineList[];
  isLoading?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trans: any;
}

const TimelinePresenter = ({
  timeline,
  isLoading,
  trans,
}: timelineListProps) => {
  return (
    <>
      <CustomDashboardCard cardSize={{ card_title: trans("Timeline") }}>
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <Grid container>
            <Compdirection>
              <CustomTimeline timeline={timeline} />
            </Compdirection>
          </Grid>
        )}
      </CustomDashboardCard>
    </>
  );
};

export default TimelinePresenter;
